import { useState } from "react";
import { Button } from "antd";
import { MinusOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import "./CTIFrame.less";

function CTIFrame({ ctiUrl }) {
  const [minimized, setMinimized] = useState(() => {
    const savedState = localStorage.getItem("cti_minimized");
    return savedState === "true";
  });

  const toggleMinimize = () => {
    const newMinimizedState = !minimized;
    setMinimized(newMinimizedState);
    localStorage.setItem("cti_minimized", newMinimizedState.toString());
  };

  return (
    <div
      className={`cti-frame-container ${minimized ? "minimized" : ""}`}
    >
      <div
        className="cti-frame-header"
        onClick={minimized ? toggleMinimize : undefined}
      >
        <span className="cti-frame-title">
          {minimized && <CustomerServiceOutlined className="cti-icon" />}
          CTI Tool
        </span>
        <div className="cti-frame-controls">
          {!minimized && (
            <Button
              type="text"
              size="small"
              icon={<MinusOutlined />}
              onClick={toggleMinimize}
              className="cti-control-btn cti-minimize-btn"
            />
          )}
        </div>
      </div>
      <div className="cti-frame-body" style={minimized?{height:"0px"}:{}} >
        <iframe
          src={ctiUrl}
          title="CTI Tool"
          className="cti-iframe"
          style={{ border: 0 }}
          allow="microphone; camera"
        />
      </div>
    </div>
  );
}

export default CTIFrame;
